




















import {Component, Prop, Vue} from 'vue-property-decorator';
import {Mixins} from 'vue-property-decorator';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
import orderDefault from '@/instance-defaults/orderDefault';
import {BOOKING_STATUS, multiNil, nil, ORDER_STATUS} from '@/common';
import GenericDialog from '@/components/Views/UI/GenericDialog.vue';

@Component({
    components: {GenericDialog},
})
export default class CancelOrderDialog extends Mixins(GlobalAlertMixin) {
    public open = false;
    public valid = false;
    public notifyPurchaser = true;
    public includeCancellationNote = false;
    public cancelReason: string = '';
    @Prop({default: orderDefault})
    public order!: any;
    public get bookingsAmount() {
        if (multiNil(this, 'order.bookings')) { return ''; }
        return this.order.bookings.length;
    }
    public get warningText() {
        return `This order contains ${this.bookingsAmount} booking${this.bookingsAmount > 1 ? 's' : ''}, ${this.bookingsAmount > 1 ? 'they' : 'it'} will be cancelled.`;
    }
    public get customerWasEmailed() {
        if (multiNil(this, 'order.customerWasEmailed')) { return false; }
        return this.order.customerWasEmailed;
    }
    public get bookingModels(): any[] {
        if (multiNil(this, 'order.bookingModels')) { return []; }
        return this.order.bookingModels;
    }
    public get assignedVendors() {
        if (nil(this.bookingModels)) { return []; }
        return this.bookingModels.filter((x) => !nil(x.assignedVendorModels)).map((x) => ({...x.assignedVendorModel, notify: true}));
    }
    public get customerRequestedCancel() {
        if (nil(this.order)) { return false; }
        return this.order.status === ORDER_STATUS.CANCELLING;
    }
    public get internalReasonLabel() {
        return this.customerRequestedCancel ? 'Additional Details' : 'Specify why you\'re cancelling this order';
    }
    public get customerCancelReason() {
        if (multiNil(this, 'order.customerCancelReason')) { return ''; }
        return this.order.customerCancelReason;
    }
    public get orderPreCancellationStatus() {
        if (multiNil(this, 'order.preCancellationStatus')) { return ''; }
        return this.order.preCancellationStatus;
    }
    public get customerCancelDetails() {
        if (multiNil(this, 'order.customerCancelDetails')) { return ''; }
        return this.order.customerCancelDetails;
    }
    public get orderCancelled() {
        if (nil(this.order)) { return false; }
        return this.order.status === ORDER_STATUS.CANCELLED;
    }
    public async cancelOrder() {
        if (nil(this.order)) {
            this.showAlert('There was a problem cancelling this order');
            return;
        }
        const { Booking, Order} = this.$FeathersVuex;

        for (const booking of this.bookingModels) {
            const b = await Booking.get(booking._id);
            b.status = BOOKING_STATUS.CANCELLED;
            b.onCancelNotifyVendor = booking.notify;
            await b.save();
        }
        const o = await Order.get(this.order._id);
        o.status = ORDER_STATUS.CANCELLED;
        o.onCancelNotifyPurchaser = this.notifyPurchaser;
        o.includeCancelReasonOnCustomerNotification = this.includeCancellationNote && !nil(this.cancelReason, true);
        o.internalCancelReason = this.cancelReason;
        await o.save();
        this.open = false;
        this.$emit('onCancelled');
    }
    public async unCancel() {
        if (nil(this.order)) {
            this.showAlert('There was a problem cancelling this order');
            return;
        }
        const { Booking, Order} = this.$FeathersVuex;

        for (const booking of this.bookingModels) {
            const b = await Booking.get(booking._id);
            b.status = BOOKING_STATUS.CANCELLED;
            await b.save();
        }
        const o = await Order.get(this.order._id);
        o.status = o.preCancellationStatus;
        o.onCancelNotifyPurchaser = this.notifyPurchaser;
        o.internalCancelReason = '';
        o.customerCancelReason = '';
        o.customerCancelDetails = '';
        await o.save();
        this.$emit('onUncancelled');
    }
}
